module.exports = __webpack_public_path__ + "img/bird-2-right.32209997.png";